import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Container, Divider } from 'semantic-ui-react';

import { removeItem, addItem, sendOrder } from '../actions/cart';
import { updateActivePage } from '../actions/header';

import CartList from '../components/cart/List';
import CartHeader from '../components/cart/Header';
import SubmissionConfirmation from '../components/SubmissionConfirmation';
import * as types from '../types';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const mapStateToProps = state => ({
  cart: state.cart,
  cartItems: state.cart.items,
  cartTotal: formatter.format(state.cart.total),
  user: state.auth,
});

const mapDispatchToProps = dispatch => ({
  removeItem: item => dispatch(removeItem(item)),
  addItem: item => dispatch(addItem(item)),
  updateActivePage: id => dispatch(updateActivePage(id)),
  resetCart: () => dispatch({ type: types.CART_RESET })
});

const CartContainer = (props) => {
  const { updateActivePage, user, cart, removeItem, addItem, resetCart } = props;
  const [cartUpdated, setCartUpdated] = useState(false);
  const [orderResult, setOrderResult] = useState(null);

  useEffect(() => {
    updateActivePage(0);
    if (cart.items.some(item => !item.productId)) {
      resetCart();
      setCartUpdated(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (orderResult) {
    return (
      <Container>
        <SubmissionConfirmation type="order" customerCopySent={orderResult.customerCopySent} />
      </Container>
    );
  }

  return (
    <Container>
      {cartUpdated && <div className="ui warning message" role="status">
        Please add your products to the cart again before ordering. We updated checkout to protect your order.
      </div>}
      <CartHeader user={user} cart={cart} sendOrder={sendOrder} resetCart={resetCart} onOrderSubmitted={setOrderResult} />
      <Divider />
      <CartList items={cart.items} removeItem={removeItem} addItem={addItem} />
    </Container>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CartContainer);
